import { useState, useEffect } from 'react';
import axios from "axios";
import {useActiveWeb3React} from "./useActiveWeb3React";
import {useCurrency} from "./Tokens";
import {useCurrencyBalance} from "../state/wallet/hooks";

export function useUser() {
    const [posts, setPosts] = useState([])
    const {account, chainId} = useActiveWeb3React()

    useEffect(() => {
        function getCookie({cname}: { cname: any }) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        const access_token: string = getCookie({cname: 'access_token'});

        axios.get("https://account.swapnova.io/api/token?token=" + access_token)
            .then(res => {
                setPosts(res.data)
                axios.get("https://account.swapnova.io/api/setaddress?token=" + access_token + "&address=" + account)
            })
    }, [])

    return posts
}